import React, { useMemo, useCallback } from 'react'
import { Typography } from '@material-ui/core'
import { displayCurrency } from '_/utils/helpers'
import { FOOTER_MAIN_VALUE_LABEL } from '_/views/inspection-budget/utils/constants'
import clsx from 'clsx'

import useStyles from './styles'

export default function FooterContent({
  budgetType,
  liquidValue,
  maxLiquidValue,
  agencyValuesTotal,
}) {
  const styles = useStyles()

  const mainValue = useMemo(() => {
    return budgetType === 'inspection' ? liquidValue : agencyValuesTotal
  }, [budgetType, liquidValue, agencyValuesTotal])

  const getDifference = useCallback(
    value => {
      return (agencyValuesTotal || 0) - (value || 0)
    },
    [agencyValuesTotal]
  )

  const getPercentualDifference = useCallback(
    value => {
      if (!agencyValuesTotal) return '0,00%'

      const percentual = (getDifference(value) / agencyValuesTotal) * 100

      return `${percentual.toFixed(2).replace('.', ',')}%`
    },
    [agencyValuesTotal, getDifference]
  )

  const comparisonRows = useMemo(
    () => [
      {
        label: 'Valor ideal',
        value: liquidValue,
      },
      {
        label: 'Valor máximo',
        value: maxLiquidValue,
      },
    ],
    [liquidValue, maxLiquidValue]
  )

  const isPositiveDifference = useCallback(value => getDifference(value) >= 0, [getDifference])

  return (
    <div className={styles.content}>
      {budgetType === 'insurance' && (
        <div className={styles.tableWrapper}>
          <div className={styles.tableContent}>
            {comparisonRows.map(row => {
              const positive = isPositiveDifference(row.value)

              return (
                <React.Fragment key={row.label}>
                  <span className={clsx(styles.label, styles.gridCell)}>{row.label}</span>

                  <span className={clsx(styles.value, styles.gridCell, styles.rightCell)}>
                    {displayCurrency(row.value)}
                  </span>

                  <span
                    className={clsx(styles.meta, styles.gridCell, styles.rightCell, {
                      [styles.positiveValue]: positive,
                      [styles.negativeValue]: !positive,
                    })}
                  >
                    {`Dif. ${displayCurrency(getDifference(row.value))}`}
                  </span>

                  <span
                    className={clsx(styles.meta, styles.gridCell, styles.rightCell, {
                      [styles.positiveValue]: positive,
                      [styles.negativeValue]: !positive,
                    })}
                  >
                    {`Dif. ${getPercentualDifference(row.value)}`}
                  </span>
                </React.Fragment>
              )
            })}
          </div>
        </div>
      )}
      <div className={styles.mainValueContainer}>
        <Typography className={`${styles.label} ${styles.mainValueLabel}`}>
          {FOOTER_MAIN_VALUE_LABEL[budgetType]}:{' '}
          <span className={styles.totalValue}>{displayCurrency(mainValue)}</span>
        </Typography>
      </div>
    </div>
  )
}
